/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict'

interface IEmpResponse extends Restangular.IResponse {
    id: number
}

interface IButtonScope extends angular.IScope {
  buttonClicked: boolean
}

interface CustomStateParam extends ng.ui.IStateParamsService {
  id: string
}

class EmployeeNewController {
    private employee
    public schema
    public forms
    public form
    public isAdmin
    public is_superuser
    public clearance
    public org_id

    public form_names = ['personal', 'email' ];

    public new_employee = {
        first_name: '',
        middle_name: '',
        last_name: '',
        email: ''
    };

    public static $inject = [
        '$scope',
        '$stateParams',
        '$state',
        'Api',
        'Employee',
        'User',
        'toaster',
        'bsLoadingOverlayService',
    ]

    constructor(
        private $scope: IButtonScope,
        private $stateParams: CustomStateParam,
        private $state: any,
        private Api: any,
        private Employee: IEmpService,
        private User: IUserService,
        private toaster: toaster.IToasterService,
        private bsLoadingOverlayService: IBsLoadingService)
    {
        this.isAdmin = User.getCurrentUser().userData.user.clearance === 'admin'
        this.is_superuser = User.getCurrentUser().userData.user.is_superuser
        if(this.is_superuser) {
        this.org_id = this.$stateParams.id || undefined
        }
        this.clearance = $state.params.role
        if (!User.hasPermission('org.add_employee')) {
            $state.go('root.home')
        }

        let superior = null
        if ($state.params.superior) {
        superior = $state.params.superior
        }

        this.employee = {
            active: true,
            displayname: '',
            monthlysalary: 0,
            superior: superior,
            extra: {
                help_boxes_visited: [],
                dismiss_tour: false,
                invite_email: false,
                personal: { contact: {work: {}}},
                employment: {}
            },
            clearance: '',
        }

        Employee.loadSchema().then((response: any) => {
            this.schema = response.data
        })
    }

    public handle_data() {
    }

    public save(doRoot: boolean): any {
        // this.$scope.buttonClicked = true;
        // this.$scope.$broadcast('schemaFormValidate')
        const canRoot = doRoot !== undefined ? doRoot : true;
        this.bsLoadingOverlayService.start({ referenceId: 'loader' });
        let formValid: boolean = true;
        let that = this;
        // this.form_names.forEach((form: string) => {
        //     this.forms[form].$submitted = true
        //     if (!this.forms[form] || this.forms[form].$invalid) {
        //         formValid = false
        //     }
        // })

        if (formValid) {
            if (this.is_superuser) {
                this.employee.org_id = this.org_id
            }
            this.employee.extra['personal']['contact']['work']['email'] = this.new_employee.email;
            this.employee.extra['personal']['first_name'] = this.new_employee.first_name;
            this.employee.extra['personal']['middle_name'] = this.new_employee.middle_name;
            this.employee.extra['personal']['last_name'] = this.new_employee.last_name;
            if (this.clearance === 'emp') {
                this.clearance = '';
            }
            this.employee.clearance = this.clearance;
            let employee: Restangular.IElement = this.Api.restangularizeElement(undefined, this.employee, 'employees');
            employee.save().then((r: any) => {
                that.$scope.$emit('$EL', 'employee.add');
                if (this.isAdmin && canRoot) {
                    let employee_id = r.id
                    this.Employee.set_clearance(employee_id, this.clearance, true).then(() => {
                    this.toaster.pop('success', 'Saved', 'User added successfully.')

                    if (this.is_superuser) {
                        // console.log('root 1');
                        this.$state.go('admin.orgs.detail', { id: this.employee.org_id })
                    } else {
                        // console.log('root 2');
                        this.$state.go('root.employees.details', { id: r.id })
                    }
                    });
                } else if(canRoot) {
                    this.toaster.pop('success', 'Saved', '')
                    if (this.is_superuser) {
                        // console.log('root 3');
                        this.$state.go('^')
                    } else {
                        // console.log('root 4');
                        this.$state.go('root.employees.details', { id: r.id })
                    }
                } else {
                    this.bsLoadingOverlayService.stop({ referenceId: 'loader' })
                }
            }, (r) => {
                this.bsLoadingOverlayService.stop({ referenceId: 'loader' })
                if(r.status="Field email is not in the correct format. (personal>contact>work>email)"){
                  this.toaster.pop('warning', 'Validation Failed', 'Invalid email address')
                }else if (r.status == 400) {
                    this.toaster.pop('warning', 'Validation Failed', 'Email already exists')
                } else {
                    this.toaster.pop('error', 'Server Error')
                }
                this.$scope.buttonClicked = false;
            })
        } else {
            this.bsLoadingOverlayService.stop({ referenceId: 'loader' })
            this.toaster.clear()
            this.toaster.pop('warning', 'Validation Failed', 'Please check the form for missing or invalid data')
            this.$scope.buttonClicked = false;
        }

    }

    public discard(): any {
        this.$state.go('^', {'from': 'employee-new'})
    }
}

angular.module('beneple.employees')
    .controller('EmployeeNewController', EmployeeNewController)



// WEBPACK FOOTER //
// ./frontend/scripts/employee/controllers/employee-new.controller.ts